import React, { useState } from 'react';
import { 
    Box, Typography, TextField, Button, List, ListItem, 
    ListItemText, ListItemSecondaryAction, IconButton, 
    Paper, Divider
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/hu';
import 'dayjs/locale/ro';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/it';

const Events = ({ data = [], updateData }) => {
    const { t } = useTranslation();
    const currentLanguage = i18n.language;
    const [eventName, setEventName] = useState('');
    const [eventDate, setEventDate] = useState(dayjs().format('YYYY-MM-DD'));

    const handleAdd = () => {
        if (!eventName.trim() || !eventDate) return;
        const newItem = {
            id: Date.now(),
            title: eventName,
            date: eventDate,
            createdAt: new Date().toISOString()
        };
        updateData([...data, newItem]);
        setEventName('');
    };

    const handleDelete = (id) => {
        updateData(data.filter(item => item.id !== id));
    };

    // Rendezés dátum szerint
    const sortedEvents = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>{t('FamilyManager.Events.Title', 'Családi események')}</Typography>
            
            <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                <TextField
                    label={t('FamilyManager.Events.Name', 'Esemény neve')}
                    value={eventName}
                    onChange={(e) => setEventName(e.target.value)}
                    size="small"
                    sx={{ flexGrow: 1 }}
                />
                <TextField
                    type="date"
                    label={t('FamilyManager.Events.Date', 'Dátum')}
                    value={eventDate}
                    onChange={(e) => setEventDate(e.target.value)}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                />
                <Button 
                    variant="contained" 
                    onClick={handleAdd}
                    startIcon={<AddIcon />}
                >
                    {t('Common.Add', 'Hozzáadás')}
                </Button>
            </Box>

            <Paper variant="outlined">
                <List>
                    {sortedEvents.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <ListItem>
                                <CalendarMonthIcon sx={{ mr: 2, color: 'primary.main' }} />
                                <ListItemText 
                                    primary={item.title} 
                                    secondary={dayjs(item.date).locale(currentLanguage).format('LL')}
                                />
                                <ListItemSecondaryAction>
                                    <IconButton edge="end" onClick={() => handleDelete(item.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                            {index < sortedEvents.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                    {sortedEvents.length === 0 && (
                        <ListItem>
                            <ListItemText 
                                primary={t('FamilyManager.Events.Empty', 'Nincs még esemény rögzítve.')} 
                                sx={{ textAlign: 'center', color: 'text.secondary', py: 2 }}
                            />
                        </ListItem>
                    )}
                </List>
            </Paper>
        </Box>
    );
};

export default Events;
